/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type Currency = "AUD" | "CAD" | "CHF" | "EUR" | "GBP" | "JPY" | "MXN" | "USD" | "%future added value";
export type ImageVersionTypeName = "large" | "master" | "medium" | "original" | "placeholder" | "small" | "thumb" | "zoom" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type CartNav_viewer = {
    readonly items?: {
        readonly edges: ReadonlyArray<{
            readonly node: {
                readonly pdpURL: string | null;
                readonly serviceId: string | null;
                readonly title: string | null;
                readonly isSold: boolean | null;
                readonly photos: ReadonlyArray<{
                    readonly versions: ReadonlyArray<{
                        readonly webPath: string | null;
                        readonly type: {
                            readonly name: ImageVersionTypeName | null;
                        } | null;
                    } | null> | null;
                } | null> | null;
                readonly pricing: {
                    readonly netPrice: {
                        readonly amount: number | null;
                        readonly currency: Currency | null;
                        readonly convertedAmountList: ReadonlyArray<{
                            readonly currency: Currency | null;
                            readonly amount: number | null;
                        } | null> | null;
                    } | null;
                    readonly salePrice: {
                        readonly amount: number | null;
                        readonly currency: Currency | null;
                        readonly convertedAmountList: ReadonlyArray<{
                            readonly currency: Currency | null;
                            readonly amount: number | null;
                        } | null> | null;
                    } | null;
                    readonly retailPrice: {
                        readonly amount: number | null;
                        readonly currency: Currency | null;
                        readonly convertedAmountList: ReadonlyArray<{
                            readonly currency: Currency | null;
                            readonly amount: number | null;
                        } | null> | null;
                    } | null;
                } | null;
            } | null;
        } | null> | null;
    } | null;
    readonly portfolios?: {
        readonly edges: ReadonlyArray<{
            readonly node: {
                readonly items: {
                    readonly totalResults: number | null;
                    readonly edges?: ReadonlyArray<{
                        readonly node: {
                            readonly item: {
                                readonly pdpURL: string | null;
                                readonly serviceId: string | null;
                                readonly title: string | null;
                                readonly isSold: boolean | null;
                                readonly photos: ReadonlyArray<{
                                    readonly versions: ReadonlyArray<{
                                        readonly webPath: string | null;
                                        readonly type: {
                                            readonly name: ImageVersionTypeName | null;
                                        } | null;
                                    } | null> | null;
                                } | null> | null;
                                readonly pricing: {
                                    readonly netPrice: {
                                        readonly amount: number | null;
                                        readonly currency: Currency | null;
                                        readonly convertedAmountList: ReadonlyArray<{
                                            readonly currency: Currency | null;
                                            readonly amount: number | null;
                                        } | null> | null;
                                    } | null;
                                    readonly salePrice: {
                                        readonly amount: number | null;
                                        readonly currency: Currency | null;
                                        readonly convertedAmountList: ReadonlyArray<{
                                            readonly currency: Currency | null;
                                            readonly amount: number | null;
                                        } | null> | null;
                                    } | null;
                                    readonly retailPrice: {
                                        readonly amount: number | null;
                                        readonly currency: Currency | null;
                                        readonly convertedAmountList: ReadonlyArray<{
                                            readonly currency: Currency | null;
                                            readonly amount: number | null;
                                        } | null> | null;
                                    } | null;
                                } | null;
                            } | null;
                        } | null;
                    } | null> | null;
                } | null;
            } | null;
        } | null> | null;
    } | null;
    readonly " $refType": "CartNav_viewer";
};
export type CartNav_viewer$data = CartNav_viewer;
export type CartNav_viewer$key = {
    readonly " $data"?: CartNav_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"CartNav_viewer">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Literal",
  "name": "first",
  "value": 3
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "amount",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "currency",
  "args": null,
  "storageKey": null
},
v3 = [
  (v1/*: any*/),
  (v2/*: any*/),
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "convertedAmountList",
    "storageKey": null,
    "args": null,
    "concreteType": "ConvertedAmountList",
    "plural": true,
    "selections": [
      (v2/*: any*/),
      (v1/*: any*/)
    ]
  }
],
v4 = [
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "pdpURL",
    "args": null,
    "storageKey": null
  },
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "serviceId",
    "args": null,
    "storageKey": null
  },
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "title",
    "args": null,
    "storageKey": null
  },
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "isSold",
    "args": null,
    "storageKey": null
  },
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "photos",
    "storageKey": null,
    "args": null,
    "concreteType": "ItemPhoto",
    "plural": true,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "versions",
        "storageKey": null,
        "args": null,
        "concreteType": "ItemPhotoVersion",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "webPath",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "type",
            "storageKey": null,
            "args": null,
            "concreteType": "ImageVersionType",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "name",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  },
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "pricing",
    "storageKey": null,
    "args": null,
    "concreteType": "ItemPricing",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "netPrice",
        "storageKey": null,
        "args": null,
        "concreteType": "FinancialAmount",
        "plural": false,
        "selections": (v3/*: any*/)
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "salePrice",
        "storageKey": null,
        "args": null,
        "concreteType": "FinancialAmount",
        "plural": false,
        "selections": (v3/*: any*/)
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "retailPrice",
        "storageKey": null,
        "args": null,
        "concreteType": "FinancialAmount",
        "plural": false,
        "selections": (v3/*: any*/)
      }
    ]
  }
];
return {
  "kind": "Fragment",
  "name": "CartNav_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "fetchPortfolioItems",
      "type": "Boolean!",
      "defaultValue": false
    },
    {
      "kind": "LocalArgument",
      "name": "fetchLocalItems",
      "type": "Boolean!",
      "defaultValue": false
    },
    {
      "kind": "LocalArgument",
      "name": "localItemIds",
      "type": "[String]",
      "defaultValue": []
    },
    {
      "kind": "RootArgument",
      "name": "userIds",
      "type": "[String]"
    },
    {
      "kind": "RootArgument",
      "name": "hasUserId",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "fetchLocalItems",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "items",
          "storageKey": null,
          "args": [
            (v0/*: any*/),
            {
              "kind": "Variable",
              "name": "itemIds",
              "variableName": "localItemIds"
            }
          ],
          "concreteType": "ItemsConnection",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "ItemsEdge",
              "plural": true,
              "selections": [
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "node",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "Item",
                  "plural": false,
                  "selections": (v4/*: any*/)
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "hasUserId",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "portfolios",
          "storageKey": null,
          "args": [
            {
              "kind": "Literal",
              "name": "first",
              "value": 1
            },
            {
              "kind": "Literal",
              "name": "portfolioTypes",
              "value": [
                "CART"
              ]
            },
            {
              "kind": "Variable",
              "name": "userIds",
              "variableName": "userIds"
            }
          ],
          "concreteType": "PortfoliosConnection",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "PortfoliosEdge",
              "plural": true,
              "selections": [
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "node",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "PortfolioV2",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "items",
                      "storageKey": "items(first:3)",
                      "args": [
                        (v0/*: any*/)
                      ],
                      "concreteType": "PortfolioItemsConnection",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "ScalarField",
                          "alias": null,
                          "name": "totalResults",
                          "args": null,
                          "storageKey": null
                        },
                        {
                          "kind": "Condition",
                          "passingValue": true,
                          "condition": "fetchPortfolioItems",
                          "selections": [
                            {
                              "kind": "LinkedField",
                              "alias": null,
                              "name": "edges",
                              "storageKey": null,
                              "args": null,
                              "concreteType": "PortfolioItemsEdge",
                              "plural": true,
                              "selections": [
                                {
                                  "kind": "LinkedField",
                                  "alias": null,
                                  "name": "node",
                                  "storageKey": null,
                                  "args": null,
                                  "concreteType": "PortfolioItemV2",
                                  "plural": false,
                                  "selections": [
                                    {
                                      "kind": "LinkedField",
                                      "alias": null,
                                      "name": "item",
                                      "storageKey": null,
                                      "args": null,
                                      "concreteType": "Item",
                                      "plural": false,
                                      "selections": (v4/*: any*/)
                                    }
                                  ]
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
})();
(node as any).hash = 'f2c05c89342abfaa5ab2d095de93e109';
export default node;
